import { useSelector } from 'react-redux'
import { Card, Tag } from 'antd'
import { faLocationArrow } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { EUROPEAN_DATE } from '../../../../utils/constants'
import { isNonEmptyArray } from '../../../../utils'
import { getStudentFullname } from '../../../../utils/entities/internship'
import { ColorsPalette } from '../../../../config/colors'

const CARD_STYLE = { flex: '0 0 auto', marginBottom: '8px' }
const BODY_STYLE = { alignItems: 'center', display: 'flex', gap: '12px', minWidth: 0, padding: '8px 12px' }
const TAGS_STYLE = { gap: '6px', minWidth: 0, overflowX: 'auto', paddingBottom: '2px' }
const LABEL_STYLE = { alignItems: 'center', display: 'flex', flex: '0 0 auto', gap: '6px', whiteSpace: 'nowrap' }

const isFocused = (internship, period) => internship.startDate.isBetween(period.startDate, period.endDate, 'day', '[]')

const GoToInternshipsBanner = ({ internships = [], period, onFocus }) => {
  const t = useSelector(selectTranslate)

  if (!isNonEmptyArray(internships)) {
    return null
  }

  const student = getStudentFullname(internships[0].internship)

  return (
    <Card className='places-occupancy-go-to' size='small' style={CARD_STYLE} bodyStyle={BODY_STYLE}>
      <span style={LABEL_STYLE}>
        <FontAwesomeIcon color={ColorsPalette.BLUE_ICON} icon={faLocationArrow} />
        <b>{t('places_occupancy_view.go_to.title')}</b>
        {student !== '/' && <span style={{ color: ColorsPalette.GREY }}>{student}</span>}
      </span>
      <div className='flex-row' style={TAGS_STYLE}>
        {internships.map(({ internship, sector }) => {
          const focused = isFocused(internship, period)
          const dates = `${internship.startDate.format(EUROPEAN_DATE)} → ${internship.endDate.format(EUROPEAN_DATE)}`

          return (
            <Tag
              key={internship.id}
              className='cu-ptr'
              color={focused ? ColorsPalette.BLUE_ICON : undefined}
              style={{ fontWeight: focused ? 'bold' : 'normal', margin: 0, whiteSpace: 'nowrap' }}
              onClick={() => onFocus(internship)}
            >
              {`${sector.name} · ${dates}`}
            </Tag>
          )
        })}
      </div>
    </Card>
  )
}

export default GoToInternshipsBanner
